module.exports = __webpack_public_path__ + "static/media/hotel1.ef529d96.png";